module.exports = __webpack_public_path__ + "img/address.c43e8708.jpg";